import destr from 'destr';

import type { SeomaticFieldsFragment } from '~/types/craft-schema';
import type { Thing } from 'schema-dts';

type MetaSiteVars = {
    siteName: string;
}

type MetaTitle = {
    title: {
        title: string
    };
}

type MetaLink = {
    home: {
        href: string,
        rel: string
    },
    canonical: {
        href: string,
        rel: string
    }
}

type JsonKeys = 'creator' | 'identity' | 'mainEntityOfPage';

export const useSchema = (seoData: MaybeRefOrGetter<SeomaticFieldsFragment['seomatic']>) => {
    const metaJsonLdContainer = computed(() => destr<Record<JsonKeys, Thing>>(toValue(seoData)?.metaJsonLdContainer));
    const metaSiteVarsContainer = computed(() => destr<MetaSiteVars>(toValue(seoData)?.metaSiteVarsContainer));
    const metaTitleContainer = computed(() => destr<MetaTitle>(toValue(seoData)?.metaTitleContainer));
    const metaLinkContainer = computed(() => destr<MetaLink>(toValue(seoData)?.metaLinkContainer));

    const url = useRequestURL();

    const webSite = computed(() => {
        return defineWebSite({
            name: metaSiteVarsContainer.value?.siteName,
            url: metaLinkContainer.value.home.href ?? `${url.protocol}//${url.host}`,
        });
    });

    const webPage = computed(() => {
        return defineWebPage({
            name: metaTitleContainer.value?.title.title,
            url: metaLinkContainer.value.canonical.href ?? url.href
        });
    });

    const json = computed<Thing[]>(() => {
        return Object.values(metaJsonLdContainer.value ?? {})?.map((value) => {
            return {
                '@id': `#${value['@type']}:${value.name}`,
                ...value,
            };
        });
    });

    useSchemaOrg([
        webSite,
        webPage,
        ...Object.values(json.value ?? {}),
    ]);
};
